import { Icon } from '@fasstech/middle-design-system';
import PropTypes from 'prop-types';

const MainSubscriberNeeds = ({
  selectedSubscriberIsMainSubscriber,
  setSelectedGrantee,
  children,
  mainSubscriber,
  selectedTab
}) => {
  if (selectedTab !== 0) {
    return null;
  }
  return (
    <div className={selectedSubscriberIsMainSubscriber ? 'w-full' : 'border rounded-xl p-4 mb-10'}>
      <div className="flex justify-between items-center">
        {!selectedSubscriberIsMainSubscriber && (
          <div
            className={'cursor-pointer items-center'}
            onClick={() => setSelectedGrantee(mainSubscriber)}>
            <Icon name={'pen'} size={20} />
          </div>
        )}
      </div>
      {children}
    </div>
  );
};

MainSubscriberNeeds.propTypes = {
  selectedSubscriberIsMainSubscriber: PropTypes.bool,
  mainSubscriber: PropTypes.object,
  selectedTab: PropTypes.number,
  setSelectedGrantee: PropTypes.func,
  children: PropTypes.node
};

export default MainSubscriberNeeds;
